import { nationalDigits, normalizePhone } from "./phone";

export interface PickedContact {
  name: string;
  phones: string[];
}

export function contactPickerAvailable(): boolean {
  return typeof navigator !== "undefined" && "contacts" in navigator && "ContactsManager" in window;
}

export async function pickContact(): Promise<PickedContact | null> {
  const manager = navigator.contacts;
  if (!manager) {
    return null;
  }
  const selected = await manager.select(["name", "tel"], { multiple: false });
  const first = selected[0];
  if (!first) {
    return null;
  }
  return { name: filled(first.name)[0] ?? "", phones: distinctPhones(first.tel) };
}

function filled(values: string[] | undefined): string[] {
  return (values ?? []).map((value) => value.trim()).filter((value) => value !== "");
}

function distinctPhones(values: string[] | undefined): string[] {
  const seen = new Set<string>();
  const kept: string[] = [];
  for (const phone of filled(values)) {
    const key = nationalDigits(normalizePhone(phone) ?? phone) || phone;
    if (!seen.has(key)) {
      seen.add(key);
      kept.push(phone);
    }
  }
  return kept;
}
